/**
 * MapErrorState — shown when map data fails to load.
 */

import React from 'react';

interface MapErrorStateProps {
  error: string;
  onRetry?: () => void;
}

export default function MapErrorState({ error, onRetry }: MapErrorStateProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-slate-50/80 backdrop-blur-sm z-10">
      <div className="text-center max-w-xs">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-red-50 flex items-center justify-center">
          <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
        </div>
        <h3 className="text-sm font-bold text-slate-700">Map data unavailable</h3>
        <p className="text-xs text-slate-500 mt-1 max-w-48 mx-auto">{error}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-3 px-4 py-2 bg-slate-600 text-white text-xs font-semibold rounded-lg hover:bg-slate-700 transition-colors"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
